import { PropTypes } from 'prop-types';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Input } from 'antd';

const ResetPassword = ({ loading, onSubmit }) => {
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    getValues,
  } = useForm({});

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label>
            Code <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            {...register('code', { required: true })}
          />
          <small style={{ color: 'red' }}>
            {errors.code && <p>Please enter the code</p>}
          </small>
        </div>
        <div className="form-group">
          <label style={{ zIndex: "999" }}>
            New Password <span className="login-danger">*</span>
          </label>
          <Controller
            name="password"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input.Password
                {...field}
                className="form-control display-flex"
              />
            )}
          />
          <small style={{ color: 'red' }}>
            {errors.password && <p>Please enter new password</p>}
          </small>
        </div>
        <div className="form-group">
          <label style={{ zIndex: "999" }}>
            Comfirm Password <span className="login-danger">*</span>
          </label>
          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              required: 'Please Enter Confirm Password',
              validate: (match) => {
                const password = getValues('password');
                return match === password || 'Passwords should match!';
              },
            }}
            render={({ field }) => (
              <Input.Password
                {...field}
                className="form-control display-flex"
              />
            )}
          />
          <small style={{ color: 'red' }}>
            {errors.confirmPassword && <p>{errors.confirmPassword.message}</p>}
          </small>
        </div>
        <div
          style={{
            color: '#b85454',
            fontSize: '13px',
            marginBottom: '16px',
            lineHeight: 1.4,
          }}
        >
          If you do not receive the verification code, please contact the administrator.
        </div>
        <div className="form-group login-btn">
          <button
            className="btn btn-primary btn-block"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Changing Password...' : 'Change Password'}
          </button>
        </div>
      </form>
    </>
  );
};

ResetPassword.propTypes = {
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ResetPassword;
